<template>
  <div class="order-management">
    <h2>商城订单管理</h2>

    <!-- 统计卡片 -->
    <el-row :gutter="16" style="margin-bottom:16px">
      <el-col :span="6">
        <el-card shadow="hover"><div class="stat-card"><span class="stat-num">{{ stats.todayOrders || 0 }}</span><span class="stat-label">今日支付订单</span></div></el-card>
      </el-col>
      <el-col :span="6">
        <el-card shadow="hover"><div class="stat-card"><span class="stat-num">{{ stats.totalOrders || 0 }}</span><span class="stat-label">累计有效订单</span></div></el-card>
      </el-col>
    </el-row>

    <!-- 搜索栏 -->
    <el-form :inline="true" :model="searchForm" class="search-bar">
      <el-form-item label="订单号">
        <el-input v-model="searchForm.orderNo" placeholder="输入订单号" clearable />
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="searchForm.orderStatus" placeholder="全部" clearable style="width:100px">
          <el-option label="待支付" :value="0" />
          <el-option label="已支付" :value="1" />
          <el-option label="已发货" :value="2" />
          <el-option label="已完成" :value="3" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="loadOrders">查询</el-button>
      </el-form-item>
    </el-form>

    <!-- 订单表格 -->
    <el-table :data="orderList" border stripe v-loading="loading" style="width:100%">
      <el-table-column prop="orderNo" label="订单号" width="160" />
      <el-table-column prop="userId" label="用户ID" width="80" />
      <el-table-column label="状态" width="90">
        <template #default="{ row }">
          <el-tag :type="statusTag(row.orderStatus)">{{ statusText(row.orderStatus) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="totalAmount" label="总价" width="80" />
      <el-table-column prop="payableAmount" label="实付" width="80" />
      <el-table-column prop="receiverName" label="收货人" width="100" />
      <el-table-column label="地址" min-width="160">
        <template #default="{ row }">{{ row.receiverAddress }}</template>
      </el-table-column>
      <el-table-column prop="logisticsCompany" label="物流公司" width="100" />
      <el-table-column prop="trackNo" label="运单号" width="140" />
      <el-table-column label="下单时间" width="160">
        <template #default="{ row }">{{ row.createdTime }}</template>
      </el-table-column>
      <el-table-column label="操作" width="140" fixed="right">
        <template #default="{ row }">
          <el-button size="small" @click="showDetail(row)">详情</el-button>
          <el-button v-if="row.orderStatus === 1" size="small" type="success" @click="openShipDialog(row)">发货</el-button>
        </template>
      </el-table-column>
    </el-table>

   <div class="pagination">
     <el-pagination background @size-change="handleSizeChange" @current-change="handlePageChange"
       :current-page="page" :page-size="size" :total="total"
       :page-sizes="[20, 50, 100]" layout="total, sizes, prev, pager, next, jumper" />
   </div>

    <!-- 订单详情弹窗 -->
    <el-dialog title="订单详情" v-model="detailVisible" width="650px">
      <div v-if="detail">
        <el-descriptions :column="2" border>
          <el-descriptions-item label="订单号">{{ detail.orderNo }}</el-descriptions-item>
          <el-descriptions-item label="状态">{{ statusText(detail.orderStatus) }}</el-descriptions-item>
          <el-descriptions-item label="总价">¥{{ detail.totalAmount }}</el-descriptions-item>
          <el-descriptions-item label="实付">¥{{ detail.payableAmount }}</el-descriptions-item>
          <el-descriptions-item label="收货人">{{ detail.receiverName }}</el-descriptions-item>
          <el-descriptions-item label="电话">{{ detail.receiverPhone }}</el-descriptions-item>
          <el-descriptions-item label="地址" :span="2">{{ detail.receiverAddress }}</el-descriptions-item>
          <el-descriptions-item label="物流">{{ detail.logisticsCompany || '-' }}</el-descriptions-item>
          <el-descriptions-item label="运单号">{{ detail.trackNo || '-' }}</el-descriptions-item>
        </el-descriptions>
        <h4 style="margin-top:16px">商品明细</h4>
        <el-table :data="detail.items" border size="small">
          <el-table-column prop="productName" label="商品" />
          <el-table-column prop="quantity" label="数量" width="60" />
          <el-table-column prop="unitPrice" label="单价" width="80" />
          <el-table-column prop="subtotalAmount" label="小计" width="80" />
        </el-table>
      </div>
    </el-dialog>

    <!-- 发货弹窗 -->
    <el-dialog title="发货" v-model="shipVisible" width="400px">
      <el-form label-width="80px">
        <el-form-item label="物流公司">
          <el-input v-model="shipForm.logisticsCompany" placeholder="如：顺丰速运" />
        </el-form-item>
        <el-form-item label="运单号">
          <el-input v-model="shipForm.trackNo" placeholder="输入运单号" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="shipVisible = false">取消</el-button>
        <el-button type="primary" @click="handleShip">确认发货</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { listOrders, getOrderDetail, shipOrder, getDashboardStats } from '@/api/mall';

export default {
  name: 'OrderManagement',
  data() {
    return {
      searchForm: { orderNo: '', orderStatus: null },
      orderList: [],
      loading: false,
      page: 1, size: 20, total: 0,
      stats: {},
      detailVisible: false, detail: null,
      shipVisible: false, shipForm: { logisticsCompany: '', trackNo: '' },
      shippingOrder: null,
    };
  },
  mounted() {
    this.loadStats();
    this.loadOrders();
  },
  methods: {
    async loadStats() {
      try { const res = await getDashboardStats(); this.stats = res.data || {}; } catch (e) {}
    },
   handlePageChange(page) {
     this.page = page;
     this.loadOrders();
   },
   async loadOrders() {
     this.loading = true;
     try {
       const res = await listOrders({ page: this.page, size: this.size, ...this.searchForm });
       const pageData = res.data || res;
       this.orderList = pageData.records || [];
       this.total = pageData.total || 0;
     } catch (e) { console.error(e); }
     finally { this.loading = false; }
   },
   handleSizeChange(size) {
     this.size = size;
     this.page = 1;
     this.loadOrders();
   },
   statusText(s) {
      const m = { 0: '待支付', 1: '已支付', 2: '已发货', 3: '已完成', 4: '已取消' };
      return m[s] || '未知';
    },
    statusTag(s) {
      const m = { 0: 'warning', 1: 'primary', 2: 'success', 3: 'info', 4: 'info' };
      return m[s] || '';
    },
    async showDetail(row) {
      try {
        const res = await getOrderDetail(row.orderNo);
        this.detail = res.data;
        this.detailVisible = true;
      } catch (e) { this.$message.error('获取详情失败'); }
    },
    openShipDialog(row) {
      this.shippingOrder = row;
      this.shipForm = { logisticsCompany: '', trackNo: '' };
      this.shipVisible = true;
    },
    async handleShip() {
      if (!this.shipForm.logisticsCompany || !this.shipForm.trackNo) {
        this.$message.warning('请填写物流公司和运单号');
        return;
      }
      try {
        await shipOrder(this.shippingOrder.orderNo, this.shipForm.logisticsCompany, this.shipForm.trackNo);
        this.$message.success('发货成功');
        this.shipVisible = false;
        this.loadOrders();
      } catch (e) { this.$message.error('发货失败'); }
    },
  },
};
</script>

<style scoped>
.order-management { padding: 0; }
.search-bar { background: #fff; padding: 16px; border-radius: 4px; margin-bottom: 16px; }
.stat-card { display:flex; flex-direction:column; align-items:center; }
.stat-num { font-size:28px; font-weight:bold; color:#409EFF; }
.stat-label { font-size:13px; color:#999; margin-top:4px; }
.pagination { margin-top: 16px; display: flex; justify-content: flex-end; }
</style>
